import { createAsyncThunk } from '@reduxjs/toolkit';
import { secure_instance } from '../../api/axios/axios-config';
import { handleApiError } from '../../api/axios/interceptors';

export const listCandidates = createAsyncThunk(
	'userProfile/getUserProfiles/getCandidates',
	async (
		{
			page = 1,
			limit = 10,
			search = '',
			sort_by = '',
			sort_direction = '',
		} = {},
		{ rejectWithValue, dispatch }
	) => {
		try {
			const params = new URLSearchParams({
				page: `${page}`,
				limit: `${limit}`,
			});
			if (search) params.set('search', search);
			if (sort_by) params.set('sort_by', sort_by);
			if (sort_direction) params.set('sort_direction', sort_direction);

			const request = await secure_instance.request({
				url: `/v1/user_profiles/candidates?${params.toString()}`,
				method: 'GET',
			});

			const responseData = request?.data;

			if (responseData?.results && Array.isArray(responseData.results)) {
				return {
					data: responseData.results,
					total: responseData.count,
					page,
					limit
				};
			}

			// Handle backwards compatibility (raw array vs paginated envelope)
			if (Array.isArray(responseData)) {
				return { data: responseData, total: responseData.length, page, limit };
			}
			return responseData;

		} catch (error) {
			return handleApiError(error, rejectWithValue, dispatch);
		}

	}
);

export const getCandidate = createAsyncThunk(
	'userProfile/getUserProfile/getCandidate',
	async ({ id, query }, { rejectWithValue, dispatch }) => {
		try {

			const request = await secure_instance.request({
				url: `/v1/user_profiles/${id}${query ? query : ''}`,
				method: 'GET',
			});

			return request?.data;

		} catch (error) {
			return handleApiError(error, rejectWithValue, dispatch);
		}

	}
);

